import React from "react";
import AuthorOrSpeakerItem from "../AuthorOrSpeakerItem";
import Divider from "../Divider";
import ResponsiveContentWidthWrapper from "../ResponsiveContentWidthWrapper";
import SectionWrapper from "../SectionWrapper";

interface Props {
  sectionSpeakers: Queries.EventPageQuery["datoCmsEvent"]["sectionSpeakers"];
}

const EventPageSectionSpeakers = ({
  sectionSpeakers: [{ speakers }],
}: Props) => {
  return (
    <SectionWrapper noBorder>
      <ResponsiveContentWidthWrapper>
        <>
          <Divider additionalClassName="mb-16" />
          <div>
            {speakers.map((speaker) => {
              const {
                speaker: [{ fullname, jobTitle, primaryPhoto }],
                introduction,
              } = speaker;

              // TODO: improve type
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const pagePath = (speaker.speaker[0] as any).pagePath;
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const company = (speaker.speaker[0] as any).company;
              const fullJobTitle = company
                ? `${jobTitle}, ${company}`
                : `${jobTitle}, foryouandyourcustomers`;

              return (
                <AuthorOrSpeakerItem
                  key={fullname}
                  itemType="speaker"
                  fullname={fullname}
                  jobTitleOrEmail={fullJobTitle}
                  description={introduction}
                  primaryPhoto={primaryPhoto}
                  pagePath={pagePath}
                />
              );
            })}
          </div>
        </>
      </ResponsiveContentWidthWrapper>
    </SectionWrapper>
  );
};

export default EventPageSectionSpeakers;
